import type { FaireProductEntity } from "../../entity_types/product";

export const p_pg9qhtzzz9: FaireProductEntity = {
  token: "p_pg9qhtzzz9",
  type: "product",
  name: "Give Peas a Chance Tea Towel",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/0159caa74aa8f29cd01917a734ff0784727f85c780d3c0b8b686d6938e59de27.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6bc2202ac61e6ea8782cf82ecee769629d70753f0c1990f10a9f66e603305673.jpeg",
    "https://cdn.faire.com/fastly/8ed33b75c080fe5bcbd72fb53e95ed65e00ec2d55713af5cc14d1576fceb140e.jpeg",
  ],
  priceDollars: 11,
  description:
    "Yes, let's all give peas a chance, but these kitchen towels are also giving loooove a chance. Personality, rich color to hide weird stains, and the cutest little border of peas ever painted - we're in deep!\n\n100% cotton\n21\" x 28\" ",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:49.497Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
